import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import NavAPIClient from "../../../api/clients/nav";
import SiteAPIClient from "../../../api/clients/site";
import Logo from "../Logo";
import SearchBar from "./SearchBar";
import Navigation from "../Navigation";
import { Container, headerHeight } from "./styles";
import { useCookies } from "react-cookie";
import { objEmpty, QUAM_QUOTE_COOKIE_KEY } from "../../Helpers";
import { useWindowSize } from "../../Helpers";

export default function Header() {
  // cookies
  const [cookies] = useCookies([QUAM_QUOTE_COOKIE_KEY]);
  // refs
  const headerRef = useRef();
  // states
  const [mainNav, setMainNav] = useState(null);
  const [logo, setLogo] = useState(null);
  const [totalProductsInCart, setTotalProductsInCart] = useState(0);
  const [searchIcon, setSearchIcon] = useState(null);
  const [headerBumpHeight, setHeaderBumpHeight] = useState(0);
  const windowSize = useWindowSize();

  let allowedToLoad = true;

  useEffect(() => {
    const load = async () => {
      try {
        // get navs available
        const API1 = new NavAPIClient();
        const response1 = await API1.getNavsAvailable();
        if (true === response1.success) {
          // find the header nav
          const _mainNav = response1.navs.find(
            (nav) => "main-nav" === nav.slug,
          );
          // if we found a nav, set it.
          _mainNav && setMainNav(_mainNav);
        }

        // get header assets
        const API2 = new SiteAPIClient();
        const response2 = await API2.getHeaderOptions();
        if (true === response2.success) {
          const { options } = response2;
          setLogo(options.header_logo.url || null);
          setSearchIcon(options.search_icon.url || null);
        }
      } catch (error) {
        console.error(error);
      }
    };
    // do not call the header yet.
    allowedToLoad && load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => (allowedToLoad = false);
  }, []);

  // when the cookies change, check and update number of favs
  useEffect(() => {
    if (!objEmpty(cookies[QUAM_QUOTE_COOKIE_KEY])) {
      let total = Object.values(cookies[QUAM_QUOTE_COOKIE_KEY]).reduce(
        (acc, curr) => acc + curr.quantity,
        0,
      );
      setTotalProductsInCart(total);
    } else {
      setTotalProductsInCart(0);
    }
  }, [cookies]);

  // fix content to header height
  useEffect(() => setHeaderBump());

  const setHeaderBump = () => {
    if (!headerRef.current) {
      return;
    }

    const body = document.body;
    body.style.paddingTop = `${headerHeight}`;
    return () => setHeaderBumpHeight(headerHeight);
  };

  return (
    <Container ref={headerRef}>
      <Logo logo={logo} />
      {mainNav && (
        <Navigation slug={mainNav.slug} headerBump={headerBumpHeight} />
      )}
      <Link
        to="/quote"
        className="bg-error absolute top-0 right-[70px] h-full min-w-20 flex items-center justify-center text-white text-base font-semibold p-4 gap-2"
      >
        {"desktop" === windowSize.currDevice ? (
          <>
            <span className="hidden md:block">Submit A Quote</span>{" "}
            {totalProductsInCart > 0 && (
              <>
                <span className="text-black">|</span>{" "}
                <span className="text-black">{totalProductsInCart}</span>
              </>
            )}
          </>
        ) : (
          <span>Quote</span>
        )}
      </Link>
      <SearchBar icon={searchIcon} />
    </Container>
  );
}
